import { NgClass } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthStore } from '../../../stores/auth.store';
import { IconComponent } from '../../atoms/icon/icon.component';
import { navigationBarItems } from './navigation-bar.constants';
import { NavigationBarItems } from './navigation-bar.types';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  imports: [RouterLink, IconComponent, NgClass],
})
export class NavigationBarComponent {
  private readonly router = inject(Router);
  private readonly authStore = inject(AuthStore);

  readonly userRole = this.authStore.userRole;

  public navigationItems: NavigationBarItems[] = navigationBarItems;
  private startX = 0;
  private endX = 0;

  public isSelected(routerLink: string): boolean {
    return this.router.url.replace('/', '') === routerLink;
  }

  @HostListener('document:touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.startX = event.touches[0].clientX;
  }

  @HostListener('document:touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    this.endX = event.changedTouches[0].clientX;

    if (this.startX - this.endX > 100) {
      this.navigateToNextPage();
    } else if (this.endX - this.startX > 100) {
      this.navigateToPreviousPage();
    }
  }

  navigateToNextPage() {
    this.navigationItems.forEach((item, index) => {
      if (this.router.url.includes(item.routerLink) && index !== this.navigationItems.length) {
        this.router.navigateByUrl(this.navigationItems[index + 1].routerLink);
      }
    });
  }

  navigateToPreviousPage() {
    this.navigationItems.forEach((item, index) => {
      if (this.router.url.includes(item.routerLink) && index !== 0) {
        this.router.navigateByUrl(this.navigationItems[index - 1].routerLink);
      }
    });
  }
}
